import React from 'react';

import ReactDOM from 'react-dom/client';
import { App } from 'components/App';
import '../src/styles/index.css';
// import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
